import axiosRef from "axios";

const axios = axiosRef.create({
  baseURL: process.env.REACT_APP_BASE_API_URL, // Centralized base URL
});

// Response interceptor to handle errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized error detected. Redirecting...");
      window.location.href = "/unauthorized"; // Redirect to the error page
    }
    return Promise.reject(error); // Forward the error for custom handling
  }
);


export const fetchTicketDetails = async (token, id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/get-ticket-detail/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
};

export const fetchAllTickets = async (token) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+"/get-tickets", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
};


export const fetchTicketNotes = async (token, id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/get-ticket-notes/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
};

export const postTicketNotes = async (token, data) => {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_API_URL+"/save-ticket-note", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
};



export const fetchTicketStatus = async (token, id) => {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_API_URL+"/get-ticket-statuses", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};

export const updateTicketStatus = async (token, data) => {
  try {
    const response = await axios.post(process.env.REACT_APP_BASE_API_URL+"/update-ticket-status", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};






